import { Component, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { HttpClient } from '@angular/common/http';
import { NgxSpinnerService } from "ngx-spinner";
import * as moment from 'moment';
import { NavigationEnd, Router } from '@angular/router';
import {environment} from '../environments/environment';

declare let gtag: (property: string, value: any, configs: any) => {};

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent implements OnInit {
  constructor(public router: Router) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        gtag('config', environment.googleAnalyticsId, {
          page_path: event.urlAfterRedirects
        });
      }
    });
  }
  
  public year_actual = '';
  public hora_actual;
  public hora_envio;
  public hora_inicial_consulta;
  public hora_limite_consulta;
  public hora_limite_pago;
  public hora_caducidad;

  public mostrar = false;
  public mostrar_mantenimiento = false;
  public mostrar_procesando_pagos = false;
  public mostrar_procesando_pagos_callback = false;
  public mostrar_consultar = true;
  public mostrar_layout = true;
  //public mostrar_adeudo;

  public web_status = "A";
  //public web_status = "M";
  
  public version_system;
  public depto_dev;
  public tel_help_dev;
  public no_procede_menos_1;
  public no_procede_menos_2;
  public no_procede_menos_3;
  public no_procede_menos_4;
  public no_procede_menos_6;
  public no_procede_menos_8;
  public no_procede_menos_9;
  //public mensaje_no_procede_title;
  //public mensaje_no_procede_body;
  public mensaje_mantenimiento;
  public hora_inicio_hrs;
  public hora_inicio_ampm;  
  public hora_fin_ampm;
  public hora_fin_hrs;
  public hora_pago_hrs;
  public hora_pago_ampm;
  public mensaje_horario_procesando_pagos;
  public mensaje_horario_aplicacion_pagos;
  public mensaje_horario_servicio;

  //public params_ventana_presupuesto_participativo = 'scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,width=400,height=500,left=-1000,top=-1000';
  public params_ventana_presupuesto_participativo = "width=1000,height=600,menubar=no,scrollbars=yes";

  title = 'pagopredial';

  system_server = "https://apipagoenlinea.guadalajara.gob.mx/";//SERVER BACKEND/API
  //system_server = "https://pagoenlinea.guadalajara.gob.mx/";//SERVER FRONTEND

  system_path = "predialApi";//Producción
  //system_path = "predialApiTest";//Prueba APP
  //system_path = "predialApiPrepo";//Preproduccion
  //system_path = "predial";//Prueba
  ////system_path = "predialApiTest2021";//Prueba//DEPRECATED
  ////system_path = "predialApiTestJS";//Prueba//DEPRECATED

  public url = this.system_server+this.system_path+"/";
  //public url_app = "https://api.guadalajara.gob.mx/";
  public url_app = "https://aytoapi.guadalajara.gob.mx/";
  public url_pdf = this.system_server+this.system_path+"/";
  public url_envio_ecommerce = this.system_server+this.system_path+"/envio_bancos";
  public url_system = "https://pagoenlinea.guadalajara.gob.mx/impuestopredial";//SERVER FRONTEND PRODUCCION
  //public url_system = "https://pagoenlinea.guadalajara.gob.mx/impuestopredial2024";//SERVER FRONTEND PRODUCCION
  //public url_system = "https://pagoenlinea.guadalajara.gob.mx/impuestopredialtest";//SERVER FRONTEND PRUEBA
  //public url_system = "https://pagoenlinea.guadalajara.gob.mx/impuestopredialprepo";//SERVER FRONTEND PREPODUCCION
  //public url_system = "http://localhost:8080/#/consulta";//SERVER LOCAL HOST 8080
  ////public url_system = "http://localhost:4200/#/consulta";//SERVER LOCAL HOST 4200
  //public url_system = "http://localhost:4200/consulta";//SERVER LOCAL HOST 4200
  //public url_presupuesto_participativo = "https://pagoenlinea.guadalajara.gob.mx/presupuestoparticipativo/encuesta/";
  public url_presupuesto_participativo = "https://presupuestoparticipativo.guadalajara.gob.mx/encuesta/";

  ngOnInit(): void {
    //this.year_actual = '2021';
    this.year_actual = moment().format('YYYY');//YEAR ACTUAL
    //this.version_system = '2021-05-17 15:02:00';
    //this.version_system = '2021-07-19 12:24:00';
    //this.version_system = '2021-11-09 16:40:00';//LEYENDA MESES SIN INTERESES
    //this.version_system = '2021-11-10 14:46:00';//CORRECCION EN TABLA ADEUDO EN CONCEPTO DESCUENTO MULTAS
    //this.version_system = '2021-12-28 23:55:00';//2021-12-28-23-55 Cambio de imagen, se implemento pagomovilapp y link para presupuesto participativo 2022
    //this.version_system = '2022-01-14 11:27:00';//2022-01-14-11-27 Se creo componet error para manejar la salida del error de SANTANDER MIT
    //this.version_system = '2022-02-24 11:03:00';//2022-02-24-11-03 Modificaciones para visualizar correctamente la respuesta de Santanter en la app 
    //this.version_system = '2022-02-24 15:24:00';//2022-02-24-15-24 Correcion en titulo y version
    //this.version_system = '2022-11-18 15:18:00';//2022-11-18-15-18 Se agrego estatus -11 para cuentas que exceden descuento buen fin
    //this.version_system = '2022-12-02 16:18:00';//2022-12-02-16-18 Modificacion para activar y desactivar plataformas bancarias dependiendo de la respuesta del backend
    //this.version_system = '2023-04-03 11:23:00';//2023-04-03-11-23 Modificacion para activar modulo HMAC en MULTIPAGOS BBVA
    //this.version_system = '2023-12-06 14:44:00';//2023-12-06-14-44 Modificacion para implementar plataforma NETPAY
    //this.version_system = '2023-12-18 17:16:00';//2023-12-18-17-16 Modificacion NETPAY correción 6° segmento en successUrl
    //this.version_system = '2023-12-19 14:10:00';//2023-12-19-14-10 Modificacion NETPAY sleep setTimeout en successUrl para dar tiempo a que se ejecute completamente el webhook
    //this.version_system = '2024-01-15 17:24:00';//2024-01-15-17-24 Modificacion horario mantenimiento
    //this.version_system = '2024-01-15 18:28:00';//2024-01-15-18-28 Modificacion mensaje horario mantenimiento
    //this.version_system = '2024-01-15 19:06:00';//2024-01-15-19-06 Modificacion mensaje horario mantenimiento variable global
    //this.version_system = '2024-01-24 21:00:00';//2024-01-24-21-00 Modificacion mensaje horario mantenimiento
    //this.version_system = '2024-01-29 14:24:00';//2024-01-29-14-24 Modificacion horario reproceso pagos
    //this.version_system = '2024-05-07 15:15:00';//2024-05-07-15-15 Modificacion leyenda plataforma MULTIPAGOS BBVA
    //this.version_system = '2024-05-23 14:32:00';//2024-05-23-14-32 Modificacion fix guardar envio bancos sin plataforma MULTIPAGOS BBVA
    //this.version_system = '2024-06-25 09:48:00';//2024-06-25-09-48 Modificacion quitar timer callback
    //this.version_system = '2024-07-15 13:51:00';//2024-07-15-13-51 CAMBIO DE URL API CAPTCHA
    //this.version_system = '2024-07-15 14:12:00';//2024-07-15-14-12 FIX CAMBIO DE URL API CAPTCHA
    //this.version_system = '2024-07-15 14:31:00';//2024-07-15-14-31-00 FIX FIX CAMBIO DE URL API CAPTCHA
    //this.version_system = '2024-07-16 09:32:00';//2024-07-16-09-32 FIX version_system
    //this.version_system = '2024-07-16 09:40:00';//2024-07-16-09-40 FIX version_system
    //this.version_system = '2025-01-14 12:25:00';//2025-01-14-12-25 Modificacion tipo de pagos plataformas bancarias
    //this.version_system = '2025-01-14 12:48:00';//2025-01-14-12-48 FIX URL Modificacion tipo de pagos plataformas bancarias
    //this.version_system = '2025-01-14 13:05:00';//2025-01-14-13-05 FIX PATH Modificacion tipo de pagos plataformas bancarias
    //this.version_system = '2025-02-21 12:27:00';//2025-02-21-12-27 FIX PATH Modificacion correo pagoselectronicos
    //this.version_system = '2025-03-07 10:05:00';//2025-03-07-10-05 FIX PATH Modificacion leyenda dias pagos
    //this.version_system = '2025-04-04 14:38:00';//2025-04-04-14-38 Cambio imagen 2024-2027
    //this.version_system = '2025-04-09 12:15:00';//2025-04-09-12-15 FIX CSS
    this.version_system = '2025-04-09 14:07:00';//2025-04-09-14-07 FIX colores CSS
    this.depto_dev = "Departamento de Software";
    this.tel_help_dev = "33-3882-4815";
    //this.tel_help_dev = "33-3818-3600 ext. 3182";
    this.no_procede_menos_1 = "<p class='text-justify'>Estimado Contribuyente, la Cuenta predial de la cual desea consultar su adeudo no fue localizada en nuestra base de datos, verifique la información que insertó e inténtelo nuevamente. Favor de no utilizar el Id Cuenta.</p><p class='text-justify'>Para aclaraciones en referencia a este tema, favor de comunicarse al teléfono 3669-13-00 ext. 1580 y 1464 al Departamento de Cartografía y Valuación de la Dirección de Catastro.</p>";
    this.no_procede_menos_2 = "<p class='text-justify'>Estimado Contribuyente, su cuenta predial ha sido exenta por la dirección de Catastro, por lo que el servicio de pago en línea no está disponible.</p><p class='text-justify'>Para aclaraciones en referencia a este tema, favor de comunicarse al teléfono 3669-13-00 ext. 1580 y 1464 al Departamento de Cartografía y Valuación de la Dirección de Catastro.</p>";
    this.no_procede_menos_3 = "<p class='text-justify'>Estimado Contribuyente, su cuenta predial ha sido cancelada por la dirección de Catastro, por lo que el servicio de pago en lnea no está disponible.</p><p class='text-justify'>Para aclaraciones en referencia a este tema, favor de comunicarse al teléfono 3669-13-00 ext. 1580 y 1464 al Departamento de Cartografía y Valuación de la Dirección de Catastro.</p>";
    this.no_procede_menos_4 = "<p class='text-justify'>Estimado Contribuyente, su cuenta predial ha sido bloqueada por la dirección de Catastro, por lo que el servicio de pago en línea no está disponible.</p><p class='text-justify'>Para aclaraciones en referencia a este tema, favor de comunicarse al teléfono 3669-13-00 ext. 1580 y 1464 al Departamento de Cartografía y Valuación de la Dirección de Catastro.</p>";
    this.no_procede_menos_6 = "<p class='text-justify'>Estimado Contribuyente, su cuenta Predial presenta Requerimientos de Pago sin practicar. Por lo cual su pago debera realizarlo exclusivamente en cualquier oficina recaudadora del Ayuntamiento de Guadalajara, por lo tanto en este momento no es posible recibirle su pago por este medio.</p><p class='text-justify'>Cualquier duda favor de comunicarse al teléfono 38-37-50-00 ext. 5088, 5094 y 5090</p>";
    this.no_procede_menos_8 = "<p class='text-justify'>Estimado Contribuyente, su cuenta Predial presenta Convenio de Pago. Por lo cual su pago debera realizarlo exclusivamente en cualquier oficina recaudadora del Ayuntamiento de Guadalajara, por lo tanto en este momento no es posible recibirle su pago por este medio.</p><p class='text-justify'>Cualquier duda favor de comunicarse al teléfono 38-37-50-00 ext. 5088, 5094 y 5090.</p>";
    this.no_procede_menos_9 = "";
    //this.hora_inicio_hrs = "05:00:00";
    //this.hora_inicio_hrs = "06:00:00";  
    this.hora_inicio_hrs = "01:00:00";//DEFAULT    
    this.hora_inicio_ampm = moment(this.hora_inicio_hrs, 'HH:mm:ss').format('hh:mm:ss a');
    //this.hora_fin_hrs = "18:50:00";
    //this.hora_fin_hrs = "21:30:00";
    this.hora_fin_hrs = "22:50:00";//DEFAULT
    this.hora_fin_ampm = moment(this.hora_fin_hrs, 'HH:mm:ss').format('hh:mm:ss a');
    //this.hora_pago_hrs = "19:00:00";
    //this.hora_pago_hrs = "21:40:00";
    this.hora_pago_hrs = "23:00:00";//DEFAULT
    this.hora_pago_ampm = moment(this.hora_pago_hrs, 'HH:mm:ss').format('hh:mm:ss a');
    this.mensaje_mantenimiento = "Estimado contribuyente y ciudadano en general le informamos que el servicio de consulta y pago en línea del impuesto Predial estará en mantenimiento momentáneamente, reanudándose el servicio a la brevedad posible.";
    this.mensaje_horario_procesando_pagos = "El sistema se encuentra aplicando los pagos realizados durante el día, momentaneamente la consulta y el pago se encuentra fuera de servicio, disculpe la molestias ocasionadas, el servicio se reanuadara a las "+this.hora_inicio_ampm+" ("+this.hora_inicio_hrs+" hrs.)";
    this.mensaje_horario_aplicacion_pagos = "Horario de aplicación de pagos de "+this.hora_fin_ampm+" ("+this.hora_fin_hrs+" hrs.) a las "+this.hora_inicio_ampm+" ("+this.hora_inicio_hrs+" hrs.)";
    this.mensaje_horario_servicio = "Por afectación de pagos con los bancos el horario de servicio para la consulta y pago del impuesto predial es de "+this.hora_inicio_ampm+" ("+this.hora_inicio_hrs+" hrs.) a las "+this.hora_fin_ampm+" ("+this.hora_fin_hrs+" hrs.)"; 
    
    if(this.web_status==='M'){
      this.mostrar = false;
      this.mostrar_mantenimiento = true;
    }
    
    this.validaHoraServicio();
  }

  public validaHoraServicio(){
    //alert('validaHoraServicio');
    this.hora_actual = moment().format('HH:mm:ss');//HORA ACTUAL
    //this.hora_actual = moment('22:49:59', 'HH:mm:ss');
    //this.hora_actual = moment('22:50:00', 'HH:mm:ss');
    //this.hora_actual = moment('22:50:01', 'HH:mm:ss');
    //this.hora_actual = moment('00:00:01', 'HH:mm:ss');
    //this.hora_actual = moment('00:50:01', 'HH:mm:ss');
    //this.hora_actual = moment('00:59:59', 'HH:mm:ss');
    //this.hora_actual = moment('01:00:00', 'HH:mm:ss');
    //this.hora_actual = moment('01:00:01', 'HH:mm:ss');
    //console.log('this.hora_actual:'+this.hora_actual);
    this.hora_actual = moment(this.hora_actual, 'HH:mm:ss');
    this.hora_inicial_consulta = moment(this.hora_inicio_hrs, 'HH:mm:ss');
    this.hora_limite_consulta = moment(this.hora_fin_hrs, 'HH:mm:ss');
    this.hora_limite_pago = moment(this.hora_pago_hrs, 'HH:mm:ss');
    /*
    console.log('this.year_actual:'+this.year_actual); //2021
    console.log('this.hora_actual:'+this.hora_actual.toDate()); // Mon May 12 2014 08:45:00
    console.log('this.hora_inicial_consulta:'+this.hora_inicial_consulta.toDate()); // Mon May 12 2014 09:00:00
    console.log('this.hora_limite_consulta:'+this.hora_limite_consulta.toDate()); // Mon May 12 2014 09:00:00
    console.log('this.hora_limite_pago:'+this.hora_limite_pago.toDate()); // Mon May 12 2014 09:00:00
    console.log(this.hora_actual.isAfter(this.hora_limite_consulta)); // true
    */
    /*
    console.log('hora_actual:'+this.hora_actual+'---hora_inicial_consulta:'+this.hora_inicial_consulta+'---hora_limite_consulta:'+this.hora_limite_consulta+'---hora_limite_pago:'+this.hora_limite_pago);
    console.log('hora_actual:'+this.hora_actual.toDate()+'---hora_inicial_consulta:'+this.hora_inicial_consulta.toDate()+'---hora_limite_consulta:'+this.hora_limite_consulta.toDate()+'---hora_limite_pago:'+this.hora_limite_pago.toDate());
    */
    if(this.hora_actual.isAfter(this.hora_limite_consulta)){
      /*
      console.log('hora_actual:'+this.hora_actual+' es mayor a hora_limite_consulta:'+this.hora_limite_consulta);
      console.log('hora_actual:'+this.hora_actual.toDate()+' es mayor a hora_limite_consulta:'+this.hora_limite_consulta.toDate());
      console.log('procesando pagos, consulta no permitida');
      */
      this.mostrar_procesando_pagos = true;
      this.mostrar = false;
      this.web_status = 'P';
    }else{
      if(this.hora_actual.isBefore(this.hora_inicial_consulta)){
        /*
        console.log('hora_actual:'+this.hora_actual+' es menor a hora_limite_consulta:'+this.hora_limite_consulta);
        console.log('hora_actual:'+this.hora_actual.toDate()+' es menor a hora_limite_consulta:'+this.hora_limite_consulta.toDate());
        console.log('procesando pagos, consulta no permitida');
        */
        this.mostrar_procesando_pagos = true;
        this.mostrar = false;
        this.web_status = 'P';        
      }else{
        /*
        console.log('hora_actual:'+this.hora_actual+' es menor a hora_limite_consulta:'+this.hora_limite_consulta+' y mayor a hora_inicial_consulta:'+this.hora_inicial_consulta+', se puede consultar y pagar');
        console.log('hora_actual:'+this.hora_actual.toDate()+' es menor a hora_limite_consulta:'+this.hora_limite_consulta.toDate()+' y mayor a hora_inicial_consulta:'+this.hora_inicial_consulta.toDate()+', se puede consultar y pagar');
        console.log('continua consulta');
        */
      }
    }

    if(this.hora_actual.isAfter(this.hora_limite_pago)){
      /*
      console.log('hora_actual:'+this.hora_actual+' es mayor a hora_limite_pago:'+this.hora_limite_pago);
      console.log('hora_actual:'+this.hora_actual.toDate()+' es mayor a hora_limite_pago:'+this.hora_limite_pago.toDate());      
      console.log('procesando pagos, pago no permitido');
      */
      this.mostrar_procesando_pagos_callback = true;
      this.mostrar = false;
      this.web_status = 'P';
    }else{
      if(this.hora_actual.isBefore(this.hora_inicial_consulta)){
        /*
        console.log('hora_actual:'+this.hora_actual+' es menor a hora_limite_pago:'+this.hora_limite_pago);
        console.log('hora_actual:'+this.hora_actual.toDate()+' es menor a hora_limite_pago:'+this.hora_limite_pago.toDate());
        console.log('procesando pagos, pago no permitido');
        */
        this.mostrar_procesando_pagos_callback = true;
        this.mostrar = false;
        this.web_status = 'P';        
      }else{
        /*
        console.log('hora_actual:'+this.hora_actual+' es menor a hora_limite_pago:'+this.hora_limite_pago+' y mayor a hora_inicial_consulta:'+this.hora_inicial_consulta+', se puede pagar');
        console.log('hora_actual:'+this.hora_actual.toDate()+' es menor a hora_limite_pago:'+this.hora_limite_pago.toDate()+' y mayor a hora_inicial_consulta:'+this.hora_inicial_consulta.toDate()+', se puede pagar');
        console.log('continua pago');
        */
      }
    }
  }//validaHoraServicio(){
  
  /*
  public recibo(recaudadora, tipo, cuenta, referencia){
    this.validaHoraServicio();
    window.open(this.url_pdf+'/recibopago/'+recaudadora+'/'+tipo+'/'+cuenta+'/'+referencia, 'popup', 'width=600,height=600');
  }//recibo(recaudadora, tipo, cuenta, referencia){
  */
  
  public recibo_salvo_buen_cobro(link){
    this.validaHoraServicio();
    window.open(link, 'popup', 'width=600,height=600');
  }//recibo_salvo_buen_cobro(link){

  public recibo_oficial(link){
    this.validaHoraServicio();
    window.open(link, 'popup', 'width=600,height=600');
  }//recibo_oficial(link){
  
  public consultar_otra(){
    window.open(this.url_system, '_self');
  }//consultar_otra(){
  
  public consultar_otra_cuenta(){
    //window.open('https://pagoenlinea.guadalajara.gob.mx/impuestopredial', '_self');
    window.open(this.url_system, '_self');
  }//consultar(){

  public abre_ventana(link){
    //this.validaHoraServicio();
    //window.open(link, 'popup', 'width=600,height=600');
    window.open(link, '_blank', 'width=600,height=600');
  }//abre_ventana(link){
}

